module.exports = __webpack_public_path__ + "assets/images/agent_fb04dde0bb6f5f3e92624f7ce30b3beb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/agent.png
// module id = 137
// module chunks = 0